<template>
  <div v-show="switchs">
    <img :src="loading" alt="">
  </div>
</template>
<script>
import api from '@/api/api.js'
export default {
  name: 'Loadings',
  data () {
    return {
      loading: api.imgAllUrlZSB + '/ZKI-load_1218.gif'
    }
  },
  props:{
    switchs:{
      type: Boolean
    }
  },
  watch: {
    switchs(value) {
      // if (value) {
      //   this.stop()
      // } else {
      //   this.move()
      // }
    }
  },
  methods: {
    /***滑动限制***/
    // stop() {
    //   var mo=function(e){e.preventDefault();};
    //   document.body.style.overflow='hidden';
    //   document.addEventListener("touchmove",mo,false);//禁止页面滑动
    // },
    //  /***取消滑动限制***/
    // move() {
    //   var mo=function(e){e.preventDefault();};
    //   document.body.style.overflow='';//出现滚动条
    //   document.removeEventListener("touchmove",mo,false);
    // }
  }
}
</script>

<style lang="scss" scoped>
  div{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10000;
    img{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 120px;
      height: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Loadings/Loading.vue